<template>
  <div id="Other_Error">

    <img :src="imgUrl" alt="" class="error_img">
    <p class="test">{{ msg }}</p>

  </div>
</template>

<script>
export default {
  name: 'Other_Error',
  data () {
    return {
      imgUrl: require("@/assets/img/404.png"),
      msg: "",
      // second: 8,
    }
  },
  mounted () {
    const { msg } = this.$route.query;
    this.msg = msg ? msg : "未知错误";

    // const timer = setInterval(() => {
    //   this.second--;
    //   if (this.second == 0) {
    //     clearInterval(timer);
    //     history.back();
    //   }
    // }, 1000);
  },
  methods: { }
}
</script>

<style scoped lang="less">
#Other_Error {
  width: 100%;
  height: 100%;
  background: #FFF;
  border: 1px solid transparent;
  box-sizing: border-box;
  .error_img {
    display: block;
    margin: 280px auto 0;
  }
  .test {
    text-align: center;
    color: #45494D;
    font-family: "PingFangSC-Regular, PingFang SC";
    font-size: 14px;
    font-weight: 400;
  }
}
</style>